import React, { useRef } from "react";
import { RawDraftContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { draftToMarkdown, DraftToMarkdownOptions, markdownToDraft } from "markdown-draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Box, makeStyles } from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
  container: {
    borderWidth: 1,
    borderColor: theme.palette.grey[400],
    borderStyle: "solid",
    borderRadius: 5,
  },
  editor: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  toolbar: {
    border: "none",
    marginTop: 3,
  },
  readOnlyInput: {},
  readOnlyWrapper: {
    borderColor: "#ddd!important",
  },
  underlineText: {
    textDecoration: "underline"
  }
}));

export type MarkdownEditorProps = {
  value: string | null;
  onChange?: (value: string | null) => void;
  readOnly?: boolean;
  dataTest?: string;
};

export const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value,
  onChange,
  readOnly = false,
  dataTest,
}) => {
  const initialValue = useRef(value);

  // if the outside world passed us null as an initial blank value, remember this.
  //  It helps if we return the same blank we were given to avoid false dirty field flagging
  const blankValue = initialValue.current === null ? null : "";

  const classes = useStyles();

  const TOOLBAR_CONFIG = {
    options: [
      "inline",
      // "blockType",
      // "fontSize",
      "list",
      //"colorPicker",
      "link",
      //"embedded",
      //"emoji",
      //"image",
      // "remove",
      //"history",
    ],
    link: {
      defaultTargetOption: "_blank",
    },
    inline: {
      inDropdown: false,
      options: ["bold", "italic"]
    }
  };

  const contentState = markdownToDraft(value || "");

  const handleChange = (newContentState: RawDraftContentState) => {
    if (onChange) {
      const markdownString = draftToMarkdown(newContentState);
      onChange(markdownString || blankValue);
    }
  };
  return (
    <Box className={classes.container}>
      <Editor
        initialContentState={contentState}
        wrapperClassName={readOnly ? classes.readOnlyWrapper : ""}
        toolbarClassName={classes.toolbar}
        editorClassName={`${classes.editor} ${
          readOnly ? classes.readOnlyInput : ""
        }`}
        onContentStateChange={handleChange}
        toolbar={TOOLBAR_CONFIG}
        toolbarHidden={readOnly}
        readOnly={readOnly}
        webDriverTestID={dataTest}
        spellCheck={true}
      />
    </Box>
  );
};
